import { render, staticRenderFns } from "./ComprasDiretasLegadas.vue?vue&type=template&id=6f38a76f&scoped=true"
import script from "./ComprasDiretasLegadas.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasLegadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38a76f",
  null
  
)

export default component.exports